import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { Layout } from 'antd';
import { styleVariables } from '../../../style';
import { MenuSideBar } from '../menu-sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Sider = Layout.Sider;
// sidebar
var SidebarContainer = styled(Sider)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  border-right: 1px solid ", ";\n  transition: 1s ease;\n  position: relative;\n  .ant-layout-sider-children {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: ", ";\n  }\n"])), styleVariables.colors.gray5, styleVariables.colors.gray1);
export var AppVisibleSidebar = function AppVisibleSidebar(props) {
  var menuItems = props.menuItems,
      translation = props.translation,
      selectedKeys = props.selectedKeys,
      bottomMenuItems = props.bottomMenuItems,
      isLoadingUserInfo = props.isLoadingUserInfo,
      firstLetterOfUsername = props.firstLetterOfUsername,
      formattedUsername = props.formattedUsername,
      navigateToPath = props.navigateToPath,
      urlNavigateAccountSettingPage = props.urlNavigateAccountSettingPage,
      handleCollapse = props.handleCollapse;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(SidebarContainer, {
      trigger: null,
      breakpoint: "lg",
      width: 256,
      children: /*#__PURE__*/_jsx(MenuSideBar, {
        menuItems: menuItems,
        translation: translation,
        selectedKeys: selectedKeys,
        bottomMenuItems: bottomMenuItems,
        isLoadingUserInfo: isLoadingUserInfo,
        firstLetterOfUsername: firstLetterOfUsername,
        urlNavigateAccountSettingPage: urlNavigateAccountSettingPage,
        formattedUsername: formattedUsername,
        navigateToPath: navigateToPath,
        handleCollapse: handleCollapse
      })
    })
  });
};